import { Sheet, SheetContent } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { SubmitButton } from '@/components/ui/app/submit-button';
import { X } from 'lucide-react';
import FormSubsidiaryCreate, { FORM_SUBSIDIARY_CREATE_ID } from '../forms/FormSubsidiaryCreate';
import { useTranslation } from 'react-i18next';

export default function SheetSubsidiaryCreate({ open, onClose, onSubmit, resetKey, isSubmitting = false }) {
    const { t } = useTranslation();
    return (
        <Sheet open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
            <SheetContent showCloseButton={false} className="w-[min(90vw,600px)] flex flex-col p-0 overflow-hidden">
                {/* Header */}
                <div className="flex items-center justify-between p-5 border-b border-border shrink-0">
                    <h2 className="text-[18px] text-foreground">{t('account:ajouterUnSousCompte')}</h2>
                    <Button
                        variant="plain"
                        color="neutral"
                        size="auto"
                        onClick={onClose}
                        className="w-10 h-10 rounded-lg bg-muted border border-border text-foreground hover:bg-border"
                    >
                        <X className="h-5 w-5" strokeWidth={1.5} />
                    </Button>
                </div>

                <FormSubsidiaryCreate key={resetKey} onSubmit={onSubmit} />

                {/* Footer */}
                <div className="border-t border-border p-5 shrink-0">
                    <div className="flex gap-3">
                        <Button
                            type="button"
                            variant="soft"
                            color="neutral"
                            size="xxl"
                            onClick={onClose}
                            disabled={isSubmitting}
                            className="flex-1 bg-surface hover:bg-surface-hover"
                        >
                            {t('account:annuler')}
                        </Button>
                        <SubmitButton
                            isSubmitting={isSubmitting}
                            loadingText={t('account:ajoutEnCours')}
                            size="xxl"
                            form={FORM_SUBSIDIARY_CREATE_ID}
                            className="flex-1"
                        >
                            {t('account:ajouter')}
                        </SubmitButton>
                    </div>
                </div>
            </SheetContent>
        </Sheet>
    );
}
